export default __webpack_public_path__ + "static/media/test-flight-appstore.607c622a.png";